import { Image } from "@heroui/react";
import { usePageMetaData } from "dsl/hooks";

export function InfoScreen({
  image,
  imageAlt,
  pageTitle,
  paragraphOne,
  paragraphTwo,
  title,
}: {
  image: string;
  imageAlt: string;
  paragraphOne: string;
  paragraphTwo: string;
  title: string;
  pageTitle: string;
}) {
  usePageMetaData({
    title: () => pageTitle,
  });

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex max-w-2xl flex-col items-center gap-8 text-center text-gray-900">
        <Image
          alt={imageAlt}
          className="h-[100px] overflow-visible"
          src={image}
        />
        <h1 className="text-heading-xxl font-bold">{title}</h1>
        <p className="text-heading-lg font-bold">{paragraphOne}</p>
        <p className="text-body-lg">{paragraphTwo}</p>
      </div>
    </div>
  );
}
